export type EventLog = {
	id: number;
	time: string,
	type: EventLogType,
	context: string,
	participants: EventLogParticipant[]
}

export type EventLogParticipant = {
	eventId: number,
	type: EventLogParticipantType,
	value: string
}

export enum EventLogType {
	SESSION_AUTHORIZED = "SESSION_AUTHORIZED",
	SESSION_UNAUTHORIZED = "SESSION_UNAUTHORIZED",
	UPLOAD_FINISHED = "UPLOAD_FINISHED",
	API_KEY_CREATED = "API_KEY_CREATED",
	API_KEY_UPDATED = "API_KEY_UPDATED",
	API_KEY_DELETED = "API_KEY_DELETED"
}

export enum EventLogParticipantType {
	USER = "USER",
	HOSTNAME = "HOSTNAME",
	SERVICE = "SERVICE",
	STATUS = "STATUS",
	API_KEY_NAME = "API_KEY_NAME"
}